module.exports = __webpack_public_path__ + "static/img/cadpa.9ec0c8fe.png";